<template>
	<div class="download">
		<div class="header">大气立体监测</div>
		<div class="download-btn">
			<van-button type="primary" size="large" @click="download">点击下载</van-button>
			<a ref="aTag" :href="downloadHref" download style="display: none"></a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'download',
	components: {},
	props: {},
	data() {
		return {
			downloadHref: 'https://vue.solarbubble.vercel.app/app-debug.apk'
		}
	},
	computed: {},
	watch: {},
	methods: {
		download() {
			this.$refs.aTag.click()
		}
	},
	created() {},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
